import {
  ArnConnectorType,
  ArnValidAuthConfig,
  AuthJwtConfig,
  UrlUtil,
} from '@arianee/arn-types';
import { ArnAuthConfig, ArnAuthConfigImpl } from './ArnAuthConfig';
import { DefaultArnAuthService } from './DefaultArnAuthService';
import { ArnConnectorFactory, DefaultConnectorFactory } from './connector';
import { ArnHttpService } from '../http';
import { ArnAuthServiceFactory } from './ArnAuthServiceFactory';
import { ArnLogger } from '../log';

export class DefaultArnAuthServiceFactory implements ArnAuthServiceFactory {
  constructor(
    readonly connectorFactory: ArnConnectorFactory = new DefaultConnectorFactory()
  ) {}

  create(
    log: ArnLogger,
    http: ArnHttpService,
    baseUrl?: string,
    spec?: ArnAuthConfig
  ) {
    const config = this.createConfig(spec, baseUrl);
    const auth = new DefaultArnAuthService(
      config,
      this.connectorFactory,
      log,
      http
    );
    if (config.autoConnect) {
      try {
        auth.connectFromCache();
      } catch (e) {
        // Absorb already connected, if any.
        if ((e as Error).message !== 'Already connected') {
          throw e;
        }
      }
    }
    return auth;
  }

  createConfig(spec?: ArnAuthConfig, baseUrl?: string): ArnValidAuthConfig {
    const jwtConfig = this.createJwtConfig(spec?.jwt, baseUrl);
    return new ArnAuthConfigImpl(
      spec?.connectorType || ArnConnectorType.Web3Modal,
      spec?.options || {},
      spec?.sigMessage ||
        `I agree to connect my wallet to ${document.location.hostname}.`,
      jwtConfig,
      spec?.autoConnect || true,
      spec?.trySwitchChainNumber
    );
  }

  createJwtConfig(
    jwtSpec: AuthJwtConfig | undefined,
    baseUrl: string | undefined
  ): AuthJwtConfig {
    return { url: UrlUtil.build(jwtSpec?.url, 'auth/jwt-sign', baseUrl) };
  }
}
